export const ORGANIZATION_BUTTON_ID = 'organization-sign-up-chat-btn'
